import { render, staticRenderFns } from "./LOVs.vue?vue&type=template&id=9935a92a"
import script from "./LOVs.vue?vue&type=script&lang=js"
export * from "./LOVs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports